import React, { ReactNode } from 'react'
import { cn } from '@/utilities/ui'

interface SectionTitleProps {
  title: string
  suffix?: string
  icon?: ReactNode
  className?: string
  rightContent?: ReactNode
}

export const SectionTitle: React.FC<SectionTitleProps> = ({
  title,
  suffix,
  icon,
  className,
  rightContent,
}) => {
  return (
    <div className={cn('flex flex-row items-center justify-between gap-2', className)}>
      <div className="flex flex-row items-center gap-2 text-primary">
        {icon && <div className="flex-shrink-0">{icon}</div>}
        <h2 className="text-2xl font-bold">
          {title} {suffix && <span className="text-foreground">{suffix}</span>}
        </h2>
      </div>
      {rightContent && <div>{rightContent}</div>}
    </div>
  )
}
